import { useCallback, useContext, useMemo } from "react";
import StreamsContext from "contexts/StreamsContext";
import { useInputTitleResolver, useNodeTitleResolver } from "views/hooks/useInputAndNodeTitles";
import { getPriorityName } from "logic/alerts/EventDefinitionPriorityEnum";
const useStreamsKeyMapper = () => {
  const streams = useContext(StreamsContext);
  const streamsMap = useMemo(() => Object.fromEntries((streams != null ? streams : []).map((stream) => [stream.id, stream])), [streams]);
  return useCallback((key) => {
    var _a, _b;
    return (_b = (_a = streamsMap[key]) == null ? void 0 : _a.title) != null ? _b : key;
  }, [streamsMap]);
};
const useInputKeyMapper = (keys) => {
  const resolveTitle = useInputTitleResolver(keys);
  return useCallback((key) => {
    var _a;
    return (_a = resolveTitle(String(key))) != null ? _a : key;
  }, [resolveTitle]);
};
const useNodeKeyMapper = (keys) => {
  const resolveTitle = useNodeTitleResolver(keys);
  return useCallback((key) => {
    var _a;
    return (_a = resolveTitle(String(key))) != null ? _a : key;
  }, [resolveTitle]);
};
const CoreKeyMappers = [
  { type: "streams", useKeyMapper: useStreamsKeyMapper },
  { type: "input", useKeyMapper: useInputKeyMapper },
  { type: "node", useKeyMapper: useNodeKeyMapper },
  { type: "priority", useKeyMapper: () => getPriorityName }
];
export default CoreKeyMappers;
